import ReactGA from "react-ga4";

// Centralized list of analytics event names. Adding a new event requires
// adding it here so the call sites stay typo-proof.
export const ANALYTICS_EVENTS = {
  ORDER_PAGE_DROP_OFF: "order_page_drop_off",
  ORDER_SUBMITTED: "order_submitted",
  PART_MANUAL_ENTRY: "part_manual_entry",
  PART_PHOTO_TAKEN: "part_photo_taken",
  PART_PARSE_SUCCESS: "part_parse_success",
  PART_PARSE_FAILED: "part_parse_failed",
  TRACKING_MANUAL_ENTRY: "tracking_manual_entry",
  TRACKING_PHOTO_TAKEN: "tracking_photo_taken",
  TRACKING_PARSE_SUCCESS: "tracking_parse_success",
  TRACKING_PARSE_FAILED: "tracking_parse_failed",
  TRACKING_SUBMITTED: "tracking_submitted",
  TRACKING_STATUS_UPDATE_CLICKED: "tracking_status_update_clicked",
} as const;

export type AnalyticsEvent =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];

export function trackEvent(
  event: AnalyticsEvent,
  params?: Record<string, unknown>,
) {
  ReactGA.event(event, params);
}
